import Constants from "../utils/consts";

var http = require("follow-redirects").https;
var qs = require("querystring");

export default async function deleteSessioniLezione(uname, token, id_lezione) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "deleteSessioniLezione.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);
        var bodyStr = body.toString();

        // Gestisce risposte vuote o non JSON (backend non ancora implementato)
        if (!bodyStr || bodyStr.trim() === "") {
          console.warn(
            "deleteSessioniLezione: API backend non risponde (probabilmente non ancora implementata)"
          );
          resolve({
            result: "KO",
            message: "Backend API non disponibile",
          });
          return;
        }

        try {
          const resp = JSON.parse(bodyStr);
          console.log("[deleteSessioniLezione] Risposta backend:", resp);
          resolve(resp);
        } catch (error) {
          console.error(
            "deleteSessioniLezione: Errore parsing JSON:",
            error,
            "Body:",
            bodyStr
          );
          resolve({
            result: "KO",
            message: "Errore nel parsing della risposta",
          });
        }
      });

      res.on("error", function(error) {
        console.error(error);
        reject(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      id_lezione: id_lezione,
    });

    req.write(postData);

    req.end();
  });
}
